import React, { useState } from 'react';
import ForgotUsernameScreen, {
  type ForgotUsernameFormError,
  type ForgotUsernameScreenMode,
} from './ForgotUsernameScreen';
import { requestUsername, RequestUsernameError } from './requestUsernameApi';

const LINKTREE_BASE_URL =
  import.meta.env.VITE_LINKTREE_BASE_URL || 'https://linktr.ee';
const TURNSTILE_SITE_KEY =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || '0x4AAAAAACrdy8oFPxj1zpDC';

const getFormErrorFromError = (
  error: RequestUsernameError
): ForgotUsernameFormError | undefined => {
  switch (error.code) {
    case 'FORGOT_USERNAME_USER_NOT_FOUND':
      return 'userNotFound';
    case 'CAPTCHA_VERIFICATION_FAILED':
      return 'captcha';
    default:
      return undefined;
  }
};

const ForgotUsernameFlow: React.FC = () => {
  const [screen, setScreen] = useState<ForgotUsernameScreenMode>('form');
  const [email, setEmail] = useState('');
  const [formError, setFormError] = useState<
    ForgotUsernameFormError | undefined
  >();

  const handleSubmit = async (submittedEmail: string, captchaToken: string) => {
    setFormError(undefined);

    try {
      await requestUsername({
        baseUrl: LINKTREE_BASE_URL,
        email: submittedEmail,
        captchaToken,
      });
      setEmail(submittedEmail);
      setScreen('sent');
    } catch (error) {
      if (error instanceof RequestUsernameError) {
        const nextFormError = getFormErrorFromError(error);

        if (nextFormError) {
          setFormError(nextFormError);
          setEmail(submittedEmail);
          setScreen('form');
          return;
        }
      }

      setScreen('technicalError');
    }
  };

  return (
    <ForgotUsernameScreen
      screen={screen}
      initialEmail={email}
      formError={formError}
      turnstileSiteKey={TURNSTILE_SITE_KEY}
      onSubmit={handleSubmit}
      onRetry={() => {
        setFormError(undefined);
        setScreen('form');
      }}
      onBackToLogin={() => {
        window.location.href = `${LINKTREE_BASE_URL}/login`;
      }}
      resetError={() => setFormError(undefined)}
    />
  );
};

export default ForgotUsernameFlow;
